import React from "react";
import { Form, FormGroup, Col, Row, Label, Input, CustomInput, Tooltip } from "reactstrap";
import isChecked from "../../files/ic_privacy_policy.svg";
import isUnChecked from "../../files/ic_privacy_policy_un_checked.svg";
import isNoSignature from "../../files/ic_no_signature.svg";
import moment from "moment";
import { primaryInsuranceProviders, allowNotificationType } from "../../constants/general.constant";
import { ROLES, USERS_ROLE } from "../../constants/role.constant";
import PatientProfileHeaderPrint from "../Reusable/PatintProfileHeaderPrint";
import { useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import lottieEmptyFile from '../../files/animation/empty_new.json';
import LottieLoader from '../../components/LottieLoader';
import BP from "../../files/devices/eocene_image_blood_monitor_transparent.png";
import GLUCOSE from "../../files/devices/eocene_image_glucose_analyzertransparent.png";
import TEMPERATURE from "../../files/devices/eocene_image_infrared_ear_and_body_termotransparent.png";
import WEIGH from "../../files/devices/eocene_image_weight_scaletransparent.png";
import PULSE from "../../files/devices/eocene_pulseoxygenetransparent.png";
import BODYTRACEBP from "../../files/devices/body_trace_blood_pressure.png";
import BODYTRACEWEIGHT from "../../files/devices/body_trace_weight_scale.png";
const _ = require("lodash");

export const ProifleDetailsPrint = (props) => {
    const { state, hideTitle, verbalAndConstantNotes } = props;
    const { isSentMonthlyReadingReport, ongoingTestingFrequencyRequest, defaultProfileConfigration, readingFrequency, intervention, latestReadingUser, ccmTotalDuration, rpmTotalDuration, deviceList, devices, patient, ongoingSaveProfileConfigration } = useSelector(
        (state) => state.careprovider
    );
    const { profile, userDetails } = useSelector(
        (state) => state.user
    );
    var signatureLink = profile ? profile.signatureImage : undefined;
    if (signatureLink && !signatureLink.indexOf("http") == 0) {
        signatureLink = "/" + signatureLink + "?" + new Date()
    }
    function fullname(cell, row) {
        if (!row.device) {
            return <div>Wrong Device</div>;
        }
        if (row.device.brand.indexOf("Body Trace Blood") > -1)
            return (
                <div className="text-center">
                    <img height="200px" src={BODYTRACEBP} className="rounded-circle img-fluid reading-icon-summary" />
                </div>
            );
        if (row.device.brand.indexOf("Body Trace Weight") > -1)
            return (
                <div className="text-center">
                    <img height="200px" src={BODYTRACEWEIGHT} className="rounded-circle img-fluid reading-icon-summary" />
                </div>
            );
        if (row.device.name.indexOf("Blood") > -1)
            return (
                <div className="text-center">
                    <img height="200px" src={BP} className="rounded-circle img-fluid reading-icon-summary" />
                </div>
            );
        if (row.device.name.indexOf("Glucose") > -1)
            return (
                <div className="text-center">
                    <img src={GLUCOSE} className="rounded-circle img-fluid reading-icon-summary" />
                </div>
            );
        if (row.device.name.indexOf("Thermometer") > -1)
            return (
                <div className="text-center">
                    <img src={TEMPERATURE} className="rounded-circle img-fluid reading-icon-summary" />
                </div>
            );
        if (row.device.name.indexOf("Weigh") > -1)
            return (
                <div className="text-center">
                    <img src={WEIGH} className="rounded-circle img-fluid reading-icon-summary" />
                </div>
            );
        if (row.device.name.indexOf("Pulse") > -1)
            return (
                <div className="text-center">
                    <img src={PULSE} className="rounded-circle img-fluid reading-icon-summary" />
                </div>
            );
        return <div className="text-center"> - </div>;
    }

    let deviceData;
    if (patient) {
        deviceData = deviceList;
    } else {
        deviceData = devices;
    }
    if (intervention && deviceData) {
        deviceData = _.filter(deviceData, function (o) {
            return o.device.brandModel != "SD-APP";
        });
    }
    const thStyle = {
    border: "1px solid #ddd",
    padding: "10px",
    textAlign: "left",
    fontWeight: "600",
    backgroundColor: "#f0f0f0"
    };

    const tdStyle = {
    border: "1px solid #ddd",
    padding: "10px",
    verticalAlign: "top",
    backgroundColor: "#fff"
    };

    return (
        <div>
        {profile && <div className="mx-auto">
           <div className="print-page-title">Required Documentation for CPT Code 99453</div>
            <PatientProfileHeaderPrint
                profile={profile}
                latestReadingUser={latestReadingUser}
                ccmTotalDuration={ccmTotalDuration}
                rpmTotalDuration={rpmTotalDuration}
            ></PatientProfileHeaderPrint>
            <div style={{ marginTop: "20px" }}>
            {/* Title */}
             <Row className="header-device-list align-items-center break-page-print">
                    <Col sm="12" md="12" className="center-label remove-table-padding">
                        <h3 className="text-center title-device">
                            <i className="mdi mdi-note-text" style={{ marginRight: "8px" }}></i> Verbal Consent and Welcome Call Completed
                        </h3>
                    </Col>
            </Row>

            {/* Table */}
            <table
                style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "20px",
                marginTop: "10px"
                }}
            >
                <thead>
                <tr>
                    <th style={{...thStyle, Width : '20%'}}>Subject</th>
                    <th style={{ ...thStyle, width: "60%", wordWrap: "break-word" }}>Note</th>
                    <th style={{...thStyle, Width : '20%'}}>Created At</th>
                </tr>
                </thead>
                <tbody>
                {verbalAndConstantNotes?.verbalConsentAndWelcomeCompleteNote?.length > 0 ? (
                    verbalAndConstantNotes.verbalConsentAndWelcomeCompleteNote.map((note) => (
                    <tr key={note._id}>
                        <td style={tdStyle}>{note.subject}</td>
                        <td style={tdStyle}>{note.body}</td>
                        <td style={tdStyle}>
                        {moment(note.createdAt).format("MMMM DD, YYYY hh:mm A")}
                        </td>
                    </tr>
                    ))
                ) : (
                    <tr>
                    <td colSpan="3" style={{ ...tdStyle, textAlign: "center" }}>
                        No notes found.
                    </td>
                    </tr>
                )}
                </tbody>
            </table>
            </div>
            <Row className="header-device-list align-items-center break-page-print">
                <Col sm="12" md="12" className="center-label remove-table-padding">
                    <h3 className="text-center title-device">
                        <i className="mdi mdi-account"></i> Profile Details
                    </h3>
                </Col>
            </Row>
            <div style={{ fontSize : '18px', marginBottom : '3%'}}>
            <FormGroup className="remove-margin break-page-print" style={{ width: "100%" }}>
                <Label className="profile-title">
                    Agreement's Status
                </Label>
                <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", width: "50%" }}>
                                {profile?.isAgreedPrivacyPolicy ? (
                                    <img src={isChecked} style={{ marginRight: 5, width: 25 }} />
                                ) : (
                                    <img src={isUnChecked} style={{ marginRight: 5, width: 25 }} />
                                )}
                                <Label className="form-check-label margin-for-label" style={{ fontWeight: 600 }}>
                                    Privacy Policy
                                </Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc", width: "50%" }} rowSpan="2">
                                <Label className="profile-title" style={{ fontWeight: 600 }}>
                                    Signature on the Agreement
                                </Label>
                                <div style={{ marginTop: "10px" }}>
                                    {signatureLink ? (
                                        <img width={155} src={signatureLink} />
                                    ) : (
                                        <div>
                                            <img className="no-signature" src={isNoSignature} />
                                            <Label className="no-signature-text">
                                                Signature could not be found!
                                            </Label>
                                        </div>
                                    )}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {profile?.isAgreedAggrement ? (
                                    <img src={isChecked} style={{ marginRight: 5, width: 25 }} />
                                ) : (
                                    <img src={isUnChecked} style={{ marginRight: 5, width: 25 }} />
                                )}
                                <Label className="form-check-label margin-for-label"  style={{ fontWeight: 600 }}>
                                    HIPPA Agreement
                                </Label>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </FormGroup>

            <FormGroup>
                <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "20px" }}>
                    <tbody>
                        <tr>
                            <td style={{ width: "30%", padding: "8px", border: "1px solid #ccc", fontWeight : 600}}>
                                <Label style={{fontWeight : 600}}>MemberId (Reference ID for CLIENT'S DB)</Label>
                            </td>
                            <td style={{ width: "70%", padding: "8px", border: "1px solid #ccc" }}>
                                {state.memberId ? state.memberId : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label style={{fontWeight : 600}}>Email</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.email ? state.email : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label style={{fontWeight : 600}}>Username</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.username ? state.username : '-'}
                            </td>
                        </tr>
                        {profile && !profile.isCareProvider && (
                            <tr>
                                <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                    <Label for="exampleText" style={{fontWeight : 600}}>Pin</Label>
                                </td>
                                <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                    {state.pin ? state.pin : '-'}
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label for="exampleText" style={{fontWeight : 600}}>Legal First Name</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.fname ? state.fname : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label for="exampleText" style={{fontWeight : 600}}>Legal Last Name</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.lname ? state.lname : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label for="exampleText" style={{fontWeight : 600}}>Legal Nickname</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.nickname ? state.nickname : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label for="exampleText" style={{fontWeight : 600}}>DOB</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.bday ? moment(state.bday).format("MMMM DD, YYYY") : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label for="isAllowNotification" style={{fontWeight : 600}}> Receive Messages </Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state && Array.isArray(state.isAllowNotification) && state.isAllowNotification.length > 0 ? (
                                    <span>{state.isAllowNotification.join(", ")}</span>
                                ) : (
                                    <span>No notifications allowed</span>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label for="exampleText" style={{fontWeight : 600}}>Cellular Phone Number</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.phone ? state.phone : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label for="exampleText" style={{fontWeight : 600}}>Alternate Phone Number</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.homeNumber ? state.homeNumber : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <label style={{fontWeight : 600}}>Work Number</label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.workNumber ? state.workNumber : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <label style={{fontWeight : 600}}>Fax Number</label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.fax ? state.fax : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <label style={{fontWeight : 600}}>Gender</label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.gender ? state.gender : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label for="exampleText" style={{fontWeight : 600}}>Street Address</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.address ? state.address : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label for="exampleText" style={{fontWeight : 600}}>City</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.city ? state.city : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label for="exampleText" style={{fontWeight : 600}}>State</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.state ? state.state : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label for="exampleText" style={{fontWeight : 600}}>Zip Code</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.zip ? state.zip : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label for="exampleText" style={{fontWeight : 600}}>Sub Organization</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.subOrganization ? state.subOrganization : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label for="exampleText" style={{fontWeight : 600}}>Height (ft)</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.height ? state.height : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label for="exampleText" style={{fontWeight : 600}}>Weight (lb)</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.weight ? state.weight : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label for="exampleText" style={{fontWeight : 600}}>Bodytrace Blood Pressure Monitor IMEI</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.bodytraceBPIMEI ? state.bodytraceBPIMEI : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label for="exampleText" style={{fontWeight : 600}}>Bodytrace Weight Scale IMEI</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.bodytraceWSIMEI ? state.bodytraceWSIMEI : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label for="exampleText" style={{fontWeight : 600}}>Mobile Device Type</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.mobileDevice ? state.mobileDevice : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label for="exampleText" style={{fontWeight : 600}}>Primary Insurance Provider</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.insuranceProvider ? state.insuranceProvider : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <Label for="exampleText" style={{fontWeight : 600}}>Secondary Insurance Provider</Label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.secondaryInsuranceProvider ? state.secondaryInsuranceProvider : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <label style={{fontWeight : 600}}>Phone Consultation Week Assigned</label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.weekAssigned ? state.weekAssigned : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <label style={{fontWeight : 600}}>Enrolled Program(s)</label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.enrolledPrograms ? state.enrolledPrograms : '-'}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <label style={{fontWeight : 600}}>Client Expectations to Follow</label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.expectationsToFollow ? state.expectationsToFollow : '-'}
                            </td>
                        </tr>
                        {profile && (profile.role == 'patient') && <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <label style={{fontWeight : 600}}>Educational Campaign</label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.educationCampaign ? state.educationCampaign : '-'}
                            </td>
                        </tr>}
                        <tr>
                            <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                <label style={{fontWeight : 600}}>Role</label>
                            </td>
                            <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                {state.role ? state.role : '-'}
                            </td>
                        </tr>
                        {(state.role == 'Other' || state.otherRole != undefined) && (
                            <tr>
                                <td style={{ padding: "8px", border: "1px solid #ccc", fontWeight : 600 }}>
                                    <label style={{fontWeight : 600}}>Other Role</label>
                                </td>
                                <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                                    {state.otherRole ? state.otherRole : '-'}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </FormGroup>
            </div>
            {profile && profile.role == ROLES.patient && (
            <div>
            <Row className="header-device-list">
                <Col sm="12" className="center-label remove-table-padding">
                    {!hideTitle && (
                        <h3 className="text-center title-device">
                            <i className="mdi mdi-sign-text"></i> My Devices
                        </h3>
                    )}
                    {hideTitle && (
                        <h3 className="text-center title-device">
                            <i className="mdi mdi-sign-text"></i> Devices&nbsp;
                            {"(" + profile.fname}{" "}
                            {profile.lname + ")"}
                        </h3>
                    )}
                </Col>
            </Row>
            <div className="scrollbar-table-cls">
                <BootstrapTable
                    wrapperClasses="table-responsive"
                    keyField="id"
                    filterPosition="top"
                    data={deviceData && _.size(deviceData) > 0 ? deviceData : []}
                    noDataIndication={() => (
                        <div>
                            <LottieLoader
                                loadLoop={false}
                                autoplayLoop={true}
                                source={lottieEmptyFile}
                                Lheight={200}
                                Lwidth={200}
                                titleSmall={"Sorry! No device found :("}
                                subTitleSmall={"We can't find any devices."}
                            />
                        </div>
                    )}
                    columns={[
                        {
                            dataField: "_id",
                            text: "Icon",
                            formatter: fullname,
                            headerStyle: (colum, colIndex) => {
                                return {
                                    padding: "16px 8px",
                                    fontSize: "15px",
                                    width: "150px",
                                    textAlign: "center"
                                };
                            }
                        },
                        {
                            dataField: "serial",
                            text: "Serial Number",
                            headerStyle: (colum, colIndex) => {
                                return {
                                    padding: "16px 8px",
                                    fontSize: "15px"
                                };
                            },
                        },
                        {
                            dataField: "device.brand",
                            text: "Device Brand",
                            headerStyle: (colum, colIndex) => {
                                return {
                                    padding: "16px 8px",
                                    fontSize: "15px"
                                };
                            },
                        },
                        {
                            dataField: "device.name",
                            text: "Device",
                            headerStyle: (colum, colIndex) => {
                                return {
                                    padding: "16px 8px",
                                    fontSize: "15px"
                                };
                            },
                        },

                        {
                            dataField: "device.brandModel",
                            text: "Device Model",
                            headerStyle: (colum, colIndex) => {
                                return {
                                    padding: "16px 8px",
                                    fontSize: "15px"
                                };
                            },
                        },
                        {
                            dataField: "performTest",
                            text: "Perform Test",
                            formatter: (cell, row) => {
                                return row.performTest ? row.performTest : "-";
                            },
                            headerStyle: (colum, colIndex) => {
                                return {
                                    padding: "16px 8px",
                                    fontSize: "15px"
                                };
                            },
                        },
                        {
                            dataField: "testingFrequency",
                            text: "Testing Frequency",
                            formatter: (cell, row) => {
                                return row.testingFrequency ? row.testingFrequency : "-";
                            },
                            headerStyle: (colum, colIndex) => {
                                return {
                                    padding: "16px 8px",
                                    fontSize: "15px"
                                };
                            },
                        },
                    ]}
                />
            </div>

            <Row className="header-device-list">
                <Col sm="12" className="center-label remove-table-padding">
                    {hideTitle && (
                        <h3 className="text-center title-device">
                            <i className="mdi mdi-sign-text"></i> Prescribed Testing Frequency&nbsp;
                        </h3>
                    )}
                </Col>
            </Row>
            {!ongoingTestingFrequencyRequest && (
                <BootstrapTable
                    wrapperClasses="table-responsive"
                    keyField="id"
                    filterPosition="top"
                    data={readingFrequency && _.size(readingFrequency) > 0 ? readingFrequency : []}
                    noDataIndication={() => (
                        <div>
                            <LottieLoader
                                loadLoop={false}
                                autoplayLoop={true}
                                source={lottieEmptyFile}
                                Lheight={200}
                                Lwidth={200}
                                titleSmall={"Sorry! No Frequency found :("}
                                subTitleSmall={"We can't find any frequency."}
                            />
                        </div>
                    )}
                    columns={[
                        {
                            dataField: "description",
                            text: "Reading Type",
                            headerStyle: (colum, colIndex) => {
                                return {
                                    padding: "16px 8px",
                                    fontSize: "15px"
                                };
                            },
                        },
                        {
                            dataField: "subTypes",
                            text: "Reading Sub Type",
                            headerStyle: (colum, colIndex) => {
                                return {
                                    padding: "16px 8px",
                                    fontSize: "15px"
                                };
                            },
                            formatter: (cell, row) => {
                                if (row.subTypes) {
                                    return row.subTypes;
                                } else {
                                    return <div className="text-center">-</div>;
                                }
                            },
                        },
                        {
                            dataField: "performTest",
                            text: "Perform Test",
                            headerStyle: (colum, colIndex) => {
                                return {
                                    padding: "16px 8px",
                                    fontSize: "15px"
                                };
                            },
                            formatter: (cell, row) => {
                                if (row.performTest) {
                                    return <div className="text-center">{row.performTest}</div>;
                                } else {
                                    return <div className="text-center">Select Perform Test</div>;
                                }
                            },
                        },
                        {
                            dataField: "testingFrequency",
                            text: "Testing Frequency",
                            headerStyle: (colum, colIndex) => {
                                return {
                                    padding: "16px 8px",
                                    fontSize: "15px"
                                };
                            },
                            formatter: (cell, row) => {
                                if (row.testingFrequency) {
                                    return <div className="text-center">{row.testingFrequency}</div>;
                                } else {
                                    return <div className="text-center">Select Frequency</div>;
                                }
                            },
                        }
                    ]}
                />
            )}

            <div className="mt-5">
                <Row className="header-device-list">
                    <Col sm="12" className="center-label remove-table-padding">
                        <h3 className="text-center title-device">
                            <i className="mdi mdi-settings"></i> Configuration
                        </h3>
                    </Col>
                </Row>
                <div>
                    <BootstrapTable
                        wrapperClasses="table-responsive"
                        keyField="id"
                        filterPosition="top"
                        data={defaultProfileConfigration && _.size(defaultProfileConfigration) > 0 ? defaultProfileConfigration : []}
                        noDataIndication={() => (
                            <div>
                                <LottieLoader
                                    loadLoop={false}
                                    autoplayLoop={true}
                                    source={lottieEmptyFile}
                                    Lheight={200}
                                    Lwidth={200}
                                    titleSmall={"Sorry! No Report found :("}
                                    subTitleSmall={"We can't find any report."}
                                />
                            </div>
                        )}
                        columns={[
                            {
                                dataField: "key",
                                text: "Name of the configuration",
                                headerStyle: (colum, colIndex) => {
                                    return {
                                        padding: "16px 8px",
                                        fontSize: "15px"
                                    };
                                },
                            },
                            {
                                dataField: "status",
                                text: "Status",
                                headerStyle: (colum, colIndex) => {
                                    return {
                                        padding: "16px 8px",
                                        fontSize: "15px"
                                    };
                                },
                                formatter: (cell, row) => {
                                    return <div className="text-center">{isSentMonthlyReadingReport ? "YES" : "NO"}</div>;
                                },
                            }
                        ]}
                    />
                </div>
            </div>
            </div>)}
        </div>}
        </div>
    )
}